import { Controller } from "@hotwired/stimulus"

// Espejo de scroll-x entre el scroller de la cabecera (.tp-dash-head-scroll,
// el thead pegajoso de la tabla) y el de las filas (.tp-dash-scroll): son
// hermanos porque dentro del scroller de filas el sticky moriría — un
// ancestro con overflow-x:auto es scrollport también en y y jamás scrollea;
// el top del thead lo resuelve el CSS (token --tp-navbar-h). En pantallas
// angostas la cabecera no tiene scrollbar propio (oculto) y sigue al de las
// filas — y viceversa si se arrastra sobre la cabecera. La comparación de
// igualdad corta el ping-pong de eventos.
export default class extends Controller {
  static targets = ["head", "body"]

  sync(event) {
    const from = event.currentTarget
    const to = from === this.headTarget ? this.bodyTarget : this.headTarget
    if (to.scrollLeft !== from.scrollLeft) to.scrollLeft = from.scrollLeft
  }
}
